import { TDropItem } from 'src/types';

export const checkStatementOptions: TDropItem[] = [
  { value: 'hsDiploma', label: 'High school awards diploma' },
  { value: 'grantCredit', label: 'School only grants credit' },
  { value: 'hsDiplomaEquivalency', label: 'School awards high school equivalency diploma' },
  { value: 'hsAwardOther', label: 'Other' },
];
